import React from 'react';
import { Flex, Box, Text, VStack, Heading, Container } from '@chakra-ui/react';

const ComingSoon: React.FC = () => {
  return (
    <Flex
      minH="100vh"
      direction="column"
      align="center"
      justify="center"
      bgGradient="linear(to-b, gray.50, white)"
      py={{ base: 8, md: 16 }}
      px={4}
    >
      <Container maxW="container.lg" textAlign="center">
        <VStack spacing={8} w="full">
          <Box
            w={{ base: 20, md: 24 }}
            h={{ base: 20, md: 24 }}
            bg="gray.100"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize={{ base: '3xl', md: '4xl' }}
            color="gray.500"
          >
            🚧
          </Box>

          <Box>
            <Heading as="h1" fontSize={{ base: '2xl', md: '3xl' }} color="text.main" mb={4} lineHeight={1.2}>
              開發中
            </Heading>
            <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" maxW="container.sm">
              此功能正在積極開發中，敬請期待！
            </Text>
          </Box>
        </VStack>
      </Container>
    </Flex>
  );
};

export default ComingSoon;
